// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2PSeX","title":"Info_title__3vAtZ","selects":"Info_selects__83_Oi","requiredAsterisk":"Info_requiredAsterisk__1JolB"};